export enum Dashboards {
  Home = '9611e43a-31f7-48ea-9635-5954d5f7a07b',
  Projects = 'e328eb39-8c57-4c94-a0ca-ce14b5790be2',
  Business = '8e9b50de-d3d1-487a-9b79-1cf0d36234f8',
  Impact = '9b3ffb51-1560-4733-a25d-ed37e106a8a5',
  Team = 'cd91fee9-83db-4820-8c25-cdce770184c6'
}
